<p 
    class="warning" 
    [@slide]="{ value: !!hide, params: { width: 10, axis: 'X', delay: 50 } }"
    [class.empty]="!message"
    *ngIf="!hide">
    {{ message }}
</p>